import L from 'leaflet';
import i18n from '@/main';

L.drawLocal = {
    draw: {
        handlers: {
            polygon: {
                tooltip: {
                    start: i18n?.t(
                        'mensagens.menuMapa.cliqueParaDesenharPoligono'
                    ),
                    cont: i18n?.t(
                        'mensagens.menuMapa.cliqueParaContinuarDesenhando'
                    ),
                    end: i18n?.t(
                        'mensagens.menuMapa.cliquePrimeiroPontoParaTerminar'
                    )
                }
            },
            polyline: {
                error: i18n?.t('mensagens.menuMapa.erro.arestasNaoPodemCruzar'),
                tooltip: {
                    start: i18n?.t('mensagens.menuMapa.clique.desenharLinha'),
                    cont: i18n?.t(
                        'mensagens.menuMapa.clique.continuarDesenhando'
                    ),
                    end: i18n?.t('mensagens.menuMapa.clique.paraTerminar')
                }
            },
            marker: {
                tooltip: {
                    start: i18n?.t('mensagens.menuMapa.clique.inserirMarcador'),
                    cont: i18n?.t(
                        'mensagens.menuMapa.clique.continuarDesenhando'
                    ),
                    end: i18n?.t('mensagens.menuMapa.clique.paraTerminar')
                }
            }
        }
    }
};
